import React from "react";

import {
    FaTasks,
    FaClock,
    FaSpinner,
    FaPauseCircle,
    FaCheckCircle,
    FaExclamationTriangle,
    FaBell,
    FaFlag,
} from "react-icons/fa";

import SectionCard from "./SectionCard";

import {
    formatNumber,
} from "../utils/dashboardFormatters";


const TaskOverview = ({
    tasks = {},
}) => {

    const rows = [

        {
            label:
                "Total Tasks",

            value:
                tasks?.totalTasks,

            icon:
                FaTasks,
        },

        {
            label:
                "Open Tasks",

            value:
                tasks?.openTasks,

            icon:
                FaClock,
        },

        {
            label:
                "Pending",

            value:
                tasks?.pending,

            icon:
                FaClock,
        },

        {
            label:
                "In Progress",

            value:
                tasks?.inProgress,

            icon:
                FaSpinner,
        },

        {
            label:
                "Waiting Follow-up",

            value:
                tasks?.waitingFollowUp,

            icon:
                FaBell,
        },

        {
            label:
                "On Hold",

            value:
                tasks?.onHold,

            icon:
                FaPauseCircle,
        },

        {
            label:
                "Overdue",

            value:
                tasks?.overdue,

            icon:
                FaExclamationTriangle,

            danger:
                true,
        },

        {
            label:
                "Due Today",

            value:
                tasks?.dueToday,

            icon:
                FaFlag,
        },

        {
            label:
                "Urgent",

            value:
                tasks?.urgent,

            icon:
                FaExclamationTriangle,

            danger:
                true,
        },

        {
            label:
                "Completed",

            value:
                tasks?.completed,

            icon:
                FaCheckCircle,
        },

    ];


    return (

        <SectionCard
            title="Task Management"
            subtitle="Pending work, follow-ups and overdue actions."
        >

            <div className="dashboard-list-grid">

                {
                    rows.map(
                        (
                            item
                        ) => {

                            const Icon =
                                item.icon;

                            return (

                                <div
                                    key={
                                        item.label
                                    }
                                    className={
                                        item.danger
                                            ? "dashboard-list-item dashboard-list-item--danger"
                                            : "dashboard-list-item"
                                    }
                                >

                                    <div className="dashboard-list-icon">

                                        <Icon />

                                    </div>


                                    <div>

                                        <span>
                                            {
                                                item.label
                                            }
                                        </span>

                                        <strong>
                                            {
                                                formatNumber(
                                                    item.value
                                                )
                                            }
                                        </strong>

                                    </div>

                                </div>

                            );

                        }
                    )
                }

            </div>

        </SectionCard>

    );
};


export default TaskOverview;